import { getAppOrigin } from "@salesforce/pwa-kit-react-sdk/utils/url"

/**
 * Retail Media Impression Reporting
 * @param {string} adId The ID for the current ad that customers see
 * @param {string} retailMediaUrl The base URL for retail media API
 */
export function sendRMImpressions(adId, retailMediaUrl) {
  const reqOptions = {
    method: 'GET',
    headers: {'Content-Type': 'application/json'},   
  }
  fetch(`${retailMediaUrl}/v1/resource/first-i/${adId}`, reqOptions)
}

/**
 * Retail Media Click Reporting
 * @param {string} adId The ID for the current ad that customers see
 * @param {string} retailMediaUrl The base URL for retail media API
 */
export function sendRMClicks(adId, retailMediaUrl) {
  const reqOptions = {
    method: 'GET',
    headers: {'Content-Type': 'application/json'},
  }
  fetch(`${retailMediaUrl}/v1/resource/second-c/${adId}`, reqOptions)
}

/**
 * Sends order tracking data to the retail media API
 * @param {object} props 
 * - id: orderId
 * - orderDate: time and date order was completed
 * - sessionId: sessionId for retail media content
 * - customerId: id for the customer
 * @returns A promise that resolves when the data has been sent
 */
export function sendOrderTrackingData(props) {
  const {id, orderDate, sessionId, customerId, orderItems} = props

  const requestBody = {
    customerId: customerId,
    sessionId: sessionId,
    orderDate: orderDate,
    id: id,
    orderItems: orderItems
  }

  const reqOptions = {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(requestBody)
  }

  fetch(`${getAppOrigin()}/api/retailMedia/orders`, reqOptions)
}